import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_select, {
      value: _ctx.computedValor,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedValor) = $event)),
      onChange: _ctx.defineValorSelecionado,
      class: "ss-tamanho-completo",
      disabled: _ctx.props.disabled
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_select_option, { value: "01" }, {
          default: _withCtx(() => [
            _createTextVNode("Álcool")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "02" }, {
          default: _withCtx(() => [
            _createTextVNode("Gasolina")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "03" }, {
          default: _withCtx(() => [
            _createTextVNode("Diesel")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "04" }, {
          default: _withCtx(() => [
            _createTextVNode("Gasogênio")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "05" }, {
          default: _withCtx(() => [
            _createTextVNode("Gás Metano")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "06" }, {
          default: _withCtx(() => [
            _createTextVNode("Elétrico/Fonte Interna")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "07" }, {
          default: _withCtx(() => [
            _createTextVNode("Elétrico/Fonte Externa")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "08" }, {
          default: _withCtx(() => [
            _createTextVNode("Gasolina/Gás Natural Combustível")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "09" }, {
          default: _withCtx(() => [
            _createTextVNode("Álcool/Gás Natural Combustível")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "10" }, {
          default: _withCtx(() => [
            _createTextVNode("Diesel/Gás Natural Combustível")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "11" }, {
          default: _withCtx(() => [
            _createTextVNode("Não informado")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "12" }, {
          default: _withCtx(() => [
            _createTextVNode("Álcool/Gasolina")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "13" }, {
          default: _withCtx(() => [
            _createTextVNode("Gasolina/Álcool")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "14" }, {
          default: _withCtx(() => [
            _createTextVNode("Diesel/Elétrico")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "15" }, {
          default: _withCtx(() => [
            _createTextVNode("Diesel/Gás Natural Combustível/Elétrico")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "16" }, {
          default: _withCtx(() => [
            _createTextVNode("Álcool/Gasolina")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "17" }, {
          default: _withCtx(() => [
            _createTextVNode("Gasolina/Álcool/Gás Natural Combustível")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "18" }, {
          default: _withCtx(() => [
            _createTextVNode("Gasolina/Elétrico")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "19" }, {
          default: _withCtx(() => [
            _createTextVNode("Álcool/Elétrico")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "20" }, {
          default: _withCtx(() => [
            _createTextVNode("Gasolina/Álcool/Elétrico")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "21" }, {
          default: _withCtx(() => [
            _createTextVNode("Diesel/Elétrico (Híbrido)")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "22" }, {
          default: _withCtx(() => [
            _createTextVNode("Gasolina/Elétrico (Híbrido)")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "23" }, {
          default: _withCtx(() => [
            _createTextVNode("Álcool/Gasolina/Elétrico (Híbrido)")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "24" }, {
          default: _withCtx(() => [
            _createTextVNode("Hidrogênio")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "onChange", "disabled"])
  ]))
}